import { Trip } from '@src/types/api/models/trip';

export type PrimaryGuestIdentity = {
  personId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};

type ResolvePrimaryGuestIdentityParams = {
  hasProfileIdentity: boolean;
  guests: Trip['guests'] | undefined;
};

/**
 * The analytics identity a Reservation carries: its primary Guest's `personId` with the same
 * traits Profile identification sends. A Profile identity wins by presence — while one exists,
 * the Reservation-derived identity is never sent, even before the Profile's own identification
 * resolves. Here the rule is applied on the data the layout already has; the App Router applies
 * it from the auth type in `_features/guest-identification`, which the sealed `src/app` boundary
 * cannot share with — if the rule or the trait set changes, change both.
 */
export function resolvePrimaryGuestIdentity({
  hasProfileIdentity,
  guests,
}: ResolvePrimaryGuestIdentityParams): PrimaryGuestIdentity | undefined {
  if (hasProfileIdentity) {
    return undefined;
  }

  const primaryGuest = guests?.find(({ isMainGuest }) => isMainGuest);

  if (!primaryGuest?.personId) {
    return undefined;
  }

  return {
    personId: primaryGuest.personId,
    email: primaryGuest.email,
    firstName: primaryGuest.firstName,
    lastName: primaryGuest.lastName,
  };
}
